import React from "react";
import qrcode from "qrcode-generator";
/* ============================================================
   Fence Works — QR codes for the paper → digital return path.
   Every customer-facing document carries a scannable code to its
   OWN destination (project portal, sign & pay, 3D viewer, review
   link), and every URL is UTM-tagged so scans are attributable:
   utm_source=fenceworks · utm_medium=qr · utm_campaign=<campaign>
   · utm_content=<which doc / which placement>. The hub logs the
   params server-side on visit (see server/src/public.js).
   ============================================================ */

function utmUrl(base: string, content: string, campaign = "job-packet") {
  if (!base) return base;
  try {
    const u = new URL(base, window.location.origin);
    u.searchParams.set("utm_source", "fenceworks");
    u.searchParams.set("utm_medium", "qr");
    u.searchParams.set("utm_campaign", campaign);
    u.searchParams.set("utm_content", content);
    return u.toString();
  } catch (e) { return base; }
}

/* print-safe QR: crisp black modules on white with a quiet zone; renders as
   inline SVG so it survives print/PDF with no network. Label under the code
   tells the customer why they'd scan it. */
function QrCode({ url, size = 72, label, sub }: any) {
  const svg = React.useMemo(() => {
    try {
      const qr = qrcode(0, "M");   // version auto, medium error correction
      qr.addData(String(url));
      qr.make();
      const n = qr.getModuleCount();
      let d = "";
      for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`;
      return { n, d };
    } catch (e) { return null; }
  }, [url]);
  if (!svg || !url) return null;
  return React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 3, width: size, flexShrink: 0 } },
    React.createElement("svg", { width: size, height: size, viewBox: `-2 -2 ${svg.n + 4} ${svg.n + 4}`, style: { background: "#fff", display: "block", border: "1px solid #e3ebf3" }, shapeRendering: "crispEdges" },
      React.createElement("path", { d: svg.d, fill: "#111" })),
    label ? React.createElement("div", { style: { fontSize: 7.5, letterSpacing: ".08em", fontWeight: 800, textAlign: "center", lineHeight: 1.3, color: "#1a2430" } }, label) : null,
    sub ? React.createElement("div", { style: { fontSize: 6.5, textAlign: "center", color: "#8d99a8" } }, sub) : null);
}

Object.assign(window, { QrCode, utmUrl });

export { QrCode, utmUrl };
